import { render, staticRenderFns } from "./PlusPromptWorkflowControls.vue?vue&type=template&id=5963e4f0&scoped=true"
import script from "./PlusPromptWorkflowControls.vue?vue&type=script&lang=js"
export * from "./PlusPromptWorkflowControls.vue?vue&type=script&lang=js"
import style0 from "./PlusPromptWorkflowControls.vue?vue&type=style&index=0&id=5963e4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5963e4f0",
  null
  
)

export default component.exports